import { render, staticRenderFns } from "./DailyHealthV3.vue?vue&type=template&id=0837ad54&scoped=true&"
import script from "./DailyHealthV3.vue?vue&type=script&lang=js&"
export * from "./DailyHealthV3.vue?vue&type=script&lang=js&"
import style0 from "./DailyHealthV3.scss?vue&type=style&index=0&id=0837ad54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0837ad54",
  null
  
)

export default component.exports